require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-collecting-data-on-paths-toward-software-development-careers.json") })
        }
      }, "path---blog-collecting-data-on-paths-toward-software-development-careers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-collecting-data-on-paths-toward-software-development-careers!./.cache/json/blog-collecting-data-on-paths-toward-software-development-careers.json
// module id = 777
// module chunks = 231608221292675